<template>
  <div class="column has-text-left">
    <button class="button is-danger js-modal-trigger" v-on:click="openModal" data-target="reopen-ticket-modal">Вернуть в работу</button>
  </div>
  <div id="reopen-ticket-modal" class="modal">
    <div class="modal-background" v-on:click="closeModal"></div>
    <div class="modal-content">
      <div class="box">
        <textarea v-model="reason" class="textarea is-dark" placeholder="Введите причину возврата обращения"></textarea>
        <button class="button is-dark is-fullwidth cancel-button" :class="deactivate ? 'is-loading' : ''" v-on:click="reopenTicket" :disabled="!reason || deactivate">ВЕРНУТЬ ОБРАЩЕНИЕ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReopenTicket",
  data() {
    return {
      reason: null,
      deactivate: false
    }
  },
  props: ['ticket'],
  mounted() {

  },
  methods: {
    reopenTicket: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/ReturnDoc`
      let data = {
        doc_guid: this.ticket['Ссылка'],
        reason: this.reason
      }
      let properies = {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            alert('Обращение возвращено в работу!')
          })
      this.closeModal(this.ticket['Номер'])
    },
    openModal: function () {
      let modal = document.getElementById('reopen-ticket-modal')
      console.log(modal.classList.toString().includes('is-active'))
      if (!modal.classList.toString().includes('is-active')) {
        modal.classList.add('is-active')
      }
    },
    closeModal: function () {
      let modal = document.getElementById('reopen-ticket-modal')
      if (modal.classList.toString().includes('is-active')) {
        modal.classList.remove('is-active')
      }
    }
  }
}
</script>

<style scoped>
.textarea {
  border-radius: 5px 5px 0 0 !important;
}
.cancel-button {
  border-radius: 0 0 5px 5px !important;
}
.is-danger {
  background: rgb(140, 0, 45) !important;
  transition: 0.3s;
}
</style>